import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TypeCrJugement } from '../models/TypeCrJugement';
import { CriterePondere } from '../models/CriterePondere';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { Step3 } from '../../../../shared/models/component-messages/mapaAT/step3';
import { CTRL_28_2 } from '../../../validators/28/ctrl28_2';
import { CTRL_28_3 } from '../../../validators/28/ctrl28_3';
import { FormMapaATControlNames } from '../formMapaATControlNames';
import { CTRL_1162 } from '../../../validators/1162/ctrl1162';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';

@Component({
  selector: 'app-type-cr-jugement',
  templateUrl: './type-cr-jugement.component.html'
})
export class TypeCrJugementComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() criteresAttribution: TypeCrJugement;

  public step3 = new Step3();
  public radioButtonValue: string;
  public radioButtonCtrlName: string;
  public critereCdc = RadioCheckBoxEnum.critereCdc;
  public criterePondere = RadioCheckBoxEnum.criterePondere;
  public critereLibre = RadioCheckBoxEnum.critereLibre;
  public criterePrix = RadioCheckBoxEnum.criterePrix;

  public rg1 = CTRL_1162.id + '_1';
  public rg2 = CTRL_28_2.id + '_1';
  public rg3 = CTRL_28_3.id + '_1';

  constructor() { }

  public ngOnInit() {

    if (!this.criteresAttribution){
      this.criteresAttribution = new TypeCrJugement();
    }else if(this.criteresAttribution && this.criteresAttribution.typeCritere === null) {
      if (this.criteresAttribution.criterePondere) {
        this.criteresAttribution.typeCritere = 'criterePondere'
      } else if (this.criteresAttribution.critereLibre) {
        this.criteresAttribution.typeCritere = 'critereLibre'
      } else if (this.criteresAttribution.criterePrix) {
        this.criteresAttribution.typeCritere = 'criterePrix'
      } else if (this.criteresAttribution.critereCDC) {
        this.criteresAttribution.typeCritere = 'critereCdc'
      }else {
      this.criteresAttribution.typeCritere = ''
      }
    }
    if (this.criteresAttribution.typeCritere.toLowerCase() === this.critereCdc.toLowerCase()) {
      this.radioButtonValue = this.critereCdc;
    } else if (this.criteresAttribution.typeCritere.toLowerCase() === this.criterePondere.toLowerCase()) {
      this.radioButtonValue = this.criterePondere;
    } else if (this.criteresAttribution.typeCritere.toLowerCase() === this.critereLibre.toLowerCase()) {
      this.radioButtonValue = this.critereLibre;
    } else if (this.criteresAttribution.typeCritere.toLocaleLowerCase() === this.criterePrix.toLowerCase()) {
      this.radioButtonValue = this.criterePrix;
    } else {
      this.radioButtonValue = RadioCheckBoxEnum.emptyValue;
    }
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_critereCDC';

  }

  addcriterePondere() {
    this.criteresAttribution.criterePondere.push(new CriterePondere());
  }

  removecriterePondere(i: number) {
    ArrayPopTools.pop(this.criteresAttribution.criterePondere, i, this.parentForm, this.getUid());
  }

  getUid() {
    return this.uid + '_SepSep_TypeCrJugement';
  }

  // TODO MBO divers attribution

  isPondere() {
    if (this.parentForm.controls[this.radioButtonCtrlName].value === this.criterePondere) {
      this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_1162Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_28_1Names_json() }));
      if (this.criteresAttribution.criterePondere == null || this.criteresAttribution.criterePondere === undefined)
        this.criteresAttribution.criterePondere = new Array(new CriterePondere());
    } else {
      // this.criteresAttribution.criterePondere = null;
    }
    return this.parentForm.controls[this.radioButtonCtrlName].value === this.criterePondere;
  }

  isLibre() {
    if (this.parentForm.controls[this.radioButtonCtrlName].value === this.critereLibre) {
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_28_2Names_json() }));
      if (this.criteresAttribution.critereLibre == null || this.criteresAttribution.critereLibre === undefined)
        this.criteresAttribution.critereLibre = new Array();
    } else {
      // this.criteresAttribution.critereLibre = null;
    }
    return this.parentForm.controls[this.radioButtonCtrlName].value === this.critereLibre;
  }

  getStepId() {
	  return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
